import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Landing } from './pages/Landing'
import { ClientIntake } from './pages/ClientIntake'
import { Dashboard } from './pages/Dashboard'
import { WhatIfScenarios } from './pages/WhatIfScenarios'
import { Optimizers } from './pages/Optimizers'
import { Login } from './pages/Login'
import { Thanks } from './pages/Thanks'
import { RequireAuth, RequireRole, GateFlag } from './routes/guards'
import type { AppRole } from './lib/supabaseClient'
import { AdvisorHome } from './pages/advisor/AdvisorHome'
import { AdminHome } from './pages/admin/AdminHome'
import { Logout } from './pages/Logout'
import { FeatureFlagProvider } from './providers/FeatureFlagProvider'

function App() {
  return (
    <Router>
      <FeatureFlagProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/thanks" element={<Thanks />} />

          <Route
            path="/intake"
            element={
              <RequireAuth>
                <RequireRole role={["CLIENT", "PROSPECT"] as AppRole[]}>
                  <ClientIntake />
                </RequireRole>
              </RequireAuth>
            }
          />

          <Route
            path="/advisor"
            element={
              <RequireAuth>
                <RequireRole role="ADVISOR">
                  <AdvisorHome />
                </RequireRole>
              </RequireAuth>
            }
          />

          <Route
            path="/dashboard/:clientId"
            element={
              <RequireAuth>
                <RequireRole role="ADVISOR">
                  <Dashboard />
                </RequireRole>
              </RequireAuth>
            }
          />

          <Route
            path="/scenarios/:clientId"
            element={
              <RequireAuth>
                <RequireRole role="ADVISOR">
                  <GateFlag flag="what_if">
                    <WhatIfScenarios />
                  </GateFlag>
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/optimizers/:clientId"
            element={
              <RequireAuth>
                <RequireRole role="ADVISOR">
                  <GateFlag flag="optimizers">
                    <Optimizers />
                  </GateFlag>
                </RequireRole>
              </RequireAuth>
            }
          />

          <Route
            path="/admin"
            element={
              <RequireAuth>
                <RequireRole role="ADMIN">
                  <AdminHome />
                </RequireRole>
              </RequireAuth>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </FeatureFlagProvider>
    </Router>
  )
}

export default App
